import { useEffect, useMemo, useState } from 'react';
import { useInventoryMovement } from '../../../hooks/inventory/useInventoryMovement';
import { useBranch } from '../../../hooks/branches/useBranch';
import { useProduct } from '../../../hooks/useProduct';
import UniversalRecordTable from '../../Tables/universalRecord/UniversalRecordTable';
import { inventoryMovementColumns } from '../../../features/inventory/movement/inventoryMovementColumns';
import { buildInventoryMovementFilters } from '../../../features/inventory/movement/buildInventoryMovementFilters';
import { FilterConfig } from '../../Tables/advancedRecord/FilterBar';

const InventoryMovementTableSection: React.FC = () => {
  const {
    list,
    paginator,
    handlerGetFilteredMovements,
    handlerClearFilteredMovements,
  } = useInventoryMovement();

  const { fetchBranchDropdown, branchDropdown } = useBranch();
  const { handlerGetProductsForDropdown, productsDropdown } = useProduct();

  const [filters, setFilters] = useState({});
  const [filtersApplied, setFiltersApplied] = useState(false);

  const pageSize = paginator?.size || 10;
  const currentPage = paginator?.number || 0;

  useEffect(() => {
    fetchBranchDropdown();
    handlerGetProductsForDropdown();
  }, []);

  const columns = useMemo(() => inventoryMovementColumns, []);

  const filterFields: FilterConfig[] = useMemo(
    () =>
      buildInventoryMovementFilters(
        branchDropdown,
        productsDropdown
      ),
    [branchDropdown, productsDropdown]
  );

  const buildMovementFilterPayload = (filters: any) => {
    const payload: any = {};

    if (filters.branchId) payload.branchId = Number(filters.branchId);
    if (filters.productId) payload.productId = Number(filters.productId);

    if (filters.startDate) payload.startDate = filters.startDate;
    if (filters.endDate) payload.endDate = filters.endDate;

    if (filters.movementType) payload.movementType = filters.movementType;

    return payload;
  };

  const handleFilterChange = (newFilters: any) => {
    const payload = buildMovementFilterPayload(newFilters);
    setFilters(payload);
    setFiltersApplied(true);
    handlerGetFilteredMovements(payload, 0, pageSize);
  };

  const handlePageChange = (page: number) => {
    handlerGetFilteredMovements(filters, page, pageSize);
  };

  const handlePageSizeChange = (size: number) => {
    handlerGetFilteredMovements(filters, 0, size);
  };

  useEffect(() => {
    if (filtersApplied) {
      handlerGetFilteredMovements(filters, currentPage, pageSize);
    }
  }, [currentPage]);

  return (
    <UniversalRecordTable
      columns={columns}
      data={list}
      onPageChange={handlePageChange}
      onPageSizeChange={handlePageSizeChange}
      filtersConfig={filterFields}
      onFilterChange={handleFilterChange}
      onResetFilters={handlerClearFilteredMovements}
      paginator={paginator}
      showPagination={true}
      enableRowClick={false}
      pageSize={pageSize}
      noDataMessage="Utiliza los filtros por sucursal, producto, fecha o tipo de movimiento para refinar tu búsqueda."
    />
  );
};

export default InventoryMovementTableSection;
